import { forwardRef, useCallback } from "react";
import type { InputHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export interface CheckboxProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  indeterminate?: boolean;
}

const checkboxClassName =
  "h-4 w-4 shrink-0 cursor-pointer rounded border-surface-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 aria-invalid:border-error-500 aria-invalid:ring-error-500";

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, indeterminate = false, ...props }, ref) => {
    const setRef = useCallback(
      (element: HTMLInputElement | null) => {
        if (element) {
          element.indeterminate = indeterminate;
        }
        if (typeof ref === "function") {
          ref(element);
        } else if (ref) {
          ref.current = element;
        }
      },
      [indeterminate, ref],
    );

    return (
      <input
        ref={setRef}
        type="checkbox"
        className={cn(checkboxClassName, className)}
        {...props}
      />
    );
  },
);

Checkbox.displayName = "Checkbox";

export { Checkbox, checkboxClassName };
